import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en";
import vi from "./locales/vi";
import zh from "./locales/zh";
import ko from "./locales/ko";
import fr from "./locales/fr";
import de from "./locales/de";
import ru from "./locales/ru";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "EN", name: "English" },
  { code: "vi", label: "VI", name: "Tiếng Việt" },
  { code: "zh", label: "中文", name: "中文" },
  { code: "ko", label: "KO", name: "한국어" },
  { code: "fr", label: "FR", name: "Français" },
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "ru", label: "RU", name: "Русский" },
];

if (!i18n.isInitialized) {
  // Instantiate the detector so we can attach our custom `geo` detector
  // BEFORE i18next.init() consumes it. Both this file and geoDetector.js
  // import the small `supportedCodes.js` module (not each other), so
  // there is no circular-import risk.
  // eslint-disable-next-line global-require
  const { geoDetector } = require("./geoDetector");
  const detector = new LanguageDetector();
  detector.addDetector(geoDetector);

  i18n
    .use(detector)
    .use(initReactI18next)
    .init({
      resources: {
        en: { translation: en },
        vi: { translation: vi },
        zh: { translation: zh },
        ko: { translation: ko },
        fr: { translation: fr },
        de: { translation: de },
        ru: { translation: ru },
      },
      fallbackLng: "en",
      supportedLngs: ["en", "vi", "zh", "ko", "fr", "de", "ru"],
      interpolation: { escapeValue: false },
      detection: {
        // Priority: user's saved choice → geoIP hint (Cloudflare) →
        // browser preference → <html lang>. localStorage is the
        // persistent cache so a user's choice is respected forever.
        order: ["localStorage", "geo", "navigator", "htmlTag"],
        caches: ["localStorage"],
        lookupLocalStorage: "dc_lang",
      },
      react: { useSuspense: false },
    });
}

export default i18n;
